module.exports = __webpack_public_path__ + "static/they-called-us-enemy-b1eac5762af895fb6d8cea3edb3da7c3.jpg";